export function omit(keys) {
  if (!Array.isArray(keys) || !keys.length) {
    return function (x) {
      return x;
    };
  }

  return function (object) {
    var keys = Object.keys(object);
    return keys.reduce(function (acc, key) {
      if (!keys.includes(key)) {
        acc[key] = object[key];
      }

      return acc;
    }, {});
  };
}